<div class="detail-page-shell" [attr.data-testid]="testId || null">
    <nav *ngIf="back" class="detail-page-breadcrumb">
        <a href="javascript:void(0)"
           class="detail-page-back"
           data-testid="detail-page-back"
           (click)="goBack()">
            <i class="fa fa-chevron-left"></i> {{ back.label }}
        </a>
    </nav>

    <ng-container *ngIf="loading">
        <div class="detail-page-loading" data-testid="detail-page-loading">
            <div class="skeleton-bar wide"></div>
            <div class="skeleton-bar narrow"></div>
        </div>
    </ng-container>

    <ng-container *ngIf="!loading && errorMessage">
        <div class="detail-page-error" data-testid="detail-page-error">
            <i class="fa fa-exclamation-circle"></i> {{ errorMessage }}
        </div>
    </ng-container>

    <ng-container *ngIf="!loading && !errorMessage">
        <div class="detail-page-header">
            <ng-content select="[detail-page-header]"></ng-content>
        </div>

        <div class="detail-page-sections">
            <ng-content></ng-content>
        </div>
    </ng-container>
</div>
